import React from 'react';
import { TextAreaStyled, Label, InputContainer } from './styled';
import { TextAreaProps } from '../../interfaces/textarea-props.interface';

export const TextArea: React.FC<TextAreaProps> = ({
    id,
    label,
    register,
    step,
    stepFinal,
    stepPosition,
    ...rest
}) => {
    return (
        <InputContainer>
            {stepPosition === 'top' && step && stepFinal ? (
                <div className="label-custom">
                    {label && <Label htmlFor={id}>{label}</Label>}
                    <div className="step">
                        <span>
                            {step.toString()}/{stepFinal.toString()}
                        </span>
                    </div>
                </div>
            ) : (
                <>{label && <Label htmlFor={id}>{label}</Label>}</>
            )}

            {register ? (
                <TextAreaStyled {...register(id)} {...rest} />
            ) : (
                <TextAreaStyled {...rest} />
            )}
            {step && stepFinal && stepPosition !== 'top' && (
                <div className="step">
                    <span>
                        {step.toString()}/{stepFinal.toString()}
                    </span>
                </div>
            )}
        </InputContainer>
    );
};
